
import { mdiMinusCircleOutline, mdiPlusCircleOutline } from '@mdi/js'
import Faq from '@/components/ui/faq/Faq.vue'
import { Cms } from '@/helpers/cms'

export default {
  components: { Faq },
  props: {
    section: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      title: this.$t('faq'),
      elements: []
    }
  },
  async fetch () {
    try {
      const { locale } = this.$i18n

      const cms = new Cms(this.$axios)

      const url = this.$config.cmsBaseURL + '/api/faq'

      const { data: faq } = await cms.get(url, {
        params: {
          locale,
          populate: '*'
        }
      })

      this.elements = faq?.attributes?.elements
    } catch (e) {
      console.error(e)
    }
  },
  icons: {
    mdiMinusCircleOutline, mdiPlusCircleOutline
  }

}
